import { UfrSlider } from "./slider-lib";


document
	.querySelectorAll( 'div[data-slider="pageentry-news-half"]' )
	.forEach( ( element: HTMLDivElement ) => {
		new UfrSlider( element, {
			alignment: "start",
		} );
	} );

document
	.querySelectorAll( 'div[data-slider="pageentry-news-full"]' )
	.forEach( ( element: HTMLDivElement ) => {
		new UfrSlider( element, {
			alignment: "middle",
		} );
	} );

document
	.querySelectorAll( 'div[data-slider="pageentry-faculty-image-slider"]' )
	.forEach( ( element: HTMLDivElement ) => {
		new UfrSlider( element, {
			alignment: "middle",
			maxVisibleSlides: 1,
		} );
	} );

document
	.querySelectorAll( 'div[data-slider="pageentry-b-image-slider"]' )
	.forEach( ( element: HTMLDivElement ) => {
		new UfrSlider( element, {
			alignment: "middle",
			maxVisibleSlides: 1,
		} );
	} );

document
	.querySelectorAll( 'div[data-slider="pageentry-coop-carousel-slider"]' )
	.forEach( ( element: HTMLDivElement ) => {
		new UfrSlider( element, {
			alignment: "middle",
			maxVisibleSlides: 5,
		} );
	} );

document
	.querySelectorAll( 'div[data-slider="pageentry-coop-image-slider"]' )
	.forEach( ( element: HTMLDivElement ) => {
		new UfrSlider( element, {
			alignment: "middle",
			maxVisibleSlides: 1,
		} );
	} );

document
	.querySelectorAll( 'div[data-slider="footer-slider"]' )
	.forEach( ( element: HTMLDivElement ) => {
		new UfrSlider( element, {
			alignment: "middle",
			maxVisibleSlides: 3,
		} );
	} );
